var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sr-base-tooltip-wrapper"},[_vm._t("activator",null,{"on":_vm.listeners}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"sr-base-tooltip",class:_vm.positionClasses},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }